    window._paq ??= [];
    (function() {
      var dom = require('./dom'), Cookie=dom.Cookie, timeout=dom.timeout;
      var u = "//analytics.greenfelt.net/";
      window._paq.push(["setTrackerUrl", u+"piwik.php"]);
      window._paq.push(["setSiteId", "1"]);
      window._paq.push(['setCustomVariable', 1, "Usertype", Cookie.list["greenfelt_user"] ? "Registered" : "Anonymous", "visit"]);
      window._paq.push(['setCustomVariable', 2, "User",     Cookie.list["greenfelt_user"] ? Cookie.list["greenfelt_user"] : "Anonymous", "visit"]);
      timeout(1000, function() {
        window._paq=window._paq.concat(piwik_vars);
        window._paq.push(['trackPageView']);
        window._paq.push(['enableLinkTracking']);
        var d=document, g=d.createElement("script"), s=d.getElementsByTagName("script")[0]; g.type="text/javascript";
        g.defer=true; g.async=true; g.src=u+"piwik.js"; s.parentNode.insertBefore(g,s);
      });
    })();
      window._paq ??= [];
    (function() {
      var dom = require('./dom'), Cookie=dom.Cookie, timeout=dom.timeout;
      var u = "//analytics.greenfelt.net/";
      window._paq.push(["setTrackerUrl", u+"piwik.php"]);
      window._paq.push(["setSiteId", "1"]);
      window._paq.push(['setCustomVariable', 1, "Usertype", Cookie.list["greenfelt_user"] ? "Registered" : "Anonymous", "visit"]);
      window._paq.push(['setCustomVariable', 2, "User",     Cookie.list["greenfelt_user"] ? Cookie.list["greenfelt_user"] : "Anonymous", "visit"]);
      timeout(1000, function() {
        window._paq=window._paq.concat(piwik_vars);
        window._paq.push(['trackPageView']);
        window._paq.push(['enableLinkTracking']);
        var d=document, g=d.createElement("script"), s=d.getElementsByTagName("script")[0]; g.type="text/javascript";
        g.defer=true; g.async=true; g.src=u+"piwik.js"; s.parentNode.insertBefore(g,s);
      });
    })();
  